export default __webpack_public_path__ + "static/media/uma.85ac113c.png";